<template>
  <div>
    <VueSlickCarousel v-bind="settings">
        <div v-for="(slide,i) in slides" :key="i">
           <div class="car_item">
            <div class="card_vue" :id="'slide' + i">
              <p class="top">{{texts[i]}}</p>
              <p class="bottom">{{names[i]}}</p>
            </div>  
          </div>
        </div>

    </VueSlickCarousel>
  </div>
</template>

<script>
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

  export default {
    props: ['vertical', 'verticalS', 'items', 'rows','controls','texts','names'],
    name: 'Carousel_cards',
    components: { VueSlickCarousel },
    data: () => ({
    settings: {
  "slidesToShow": 4,
  "slidesToScroll": 1,
  "arrows": false,
    "responsive": [
    {
      "breakpoint": 1700,
      "settings": {
        "slidesToShow": 3,
        "slidesToScroll": 1,
      }
    },
    {
      "breakpoint": 1300,
      "settings": {
        "slidesToShow": 2,
        "slidesToScroll": 1,
      }
    },
    {
      "breakpoint": 950,
      "settings": {
        "slidesToShow": 1,
        "slidesToScroll": 1,
      }
    },
  ]
    },
    slides: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10"
    ]
    })
  }
</script>

<style>

  .slick-slider{
    margin-left: 35px !important;
    margin-right: 25px !important;
    max-width: 100% !important;
    margin-left: auto !important;
    margin-right: auto !important;
    padding-top: 50px;
    cursor: pointer;
  }

  .card_vue{
    background: #a71d54;
    padding: 200px;
    border-radius: 10px;
    width: 300px;
    height: 600px;
    margin-left: auto;
    margin-right: auto;
    color: #fff;
    margin-bottom:20px;
    background-size: cover;
    border-bottom: 9px solid #E27E32;
    position: relative;
  }
  .card_vue .bottom{
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0)), color-stop(35%, rgba(0, 0, 0, 0.15)), color-stop(75%, black));
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.15) 35%, black 75%);
    padding: 200px 46px 79px 46px;
    text-align: center;
    font-size: 20px;
  }

  .slick-next{
    background: #a71d54 !important;
    border-radius: 50% !important;
    color: #a71d54 !important;
    width: 40px;
    height: 40px; 
    background: url(https://vue.anvetogroup.com/wp-content/uploads/2022/11/right.png) !important;
    background-size: cover !important;
    border:3px solid #a71d54 !important;
  }
  .slick-prev{
    background: #a71d54 !important;
    border-radius: 50% !important;
    color: #a71d54 !important;
    height: 40px;
    width: 40px;
    background: url(https://vue.anvetogroup.com/wp-content/uploads/2022/11/left.png) !important;
    background-size: cover !important;
    border:3px solid #a71d54 !important;

  }
  .slick-prev::before{
    content: "";
  }
  .slick-next::before{
    content: "";
  }
  @media only screen and (max-width: 1300px) {
    .slick-slider{
      max-width: 85% !important;
    }
  }
   @media only screen and (max-width: 600px) {
    .card_vue{
      width: 200px !important;
      height: 300px !important;
      padding: 150px !important;
    }
  }
  @media only screen and (max-width: 450px) {
    .card_vue{
      padding: 100px !important;
      height: 250px !important;
    }
  }
  
</style>